import { render, staticRenderFns } from "./PlannersTable.vue?vue&type=template&id=0635df21&scoped=true&"
import script from "./PlannersTable.vue?vue&type=script&lang=js&"
export * from "./PlannersTable.vue?vue&type=script&lang=js&"
import style0 from "./PlannersTable.vue?vue&type=style&index=0&id=0635df21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0635df21",
  null
  
)

export default component.exports